import React, { Component } from 'react'

import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'


// Components.
import Header from './Header';
import BasketComponent from '../b2b/BasketComponent';

// Store.
import { RootState } from '../../store';
import { ICollectionState  } from '../../store/collections/reducers'
import { IProductState  } from '../../store/products/reducers'
import { getCollections  } from '../../store/collections/actions';
import { getOrderTypes } from '../../store/products/actions';
import { IUserSate } from '../../store/user/reducers';
import { IOrderState } from '../../store/order/orderStore';
import { resetFilter } from '../../store/session/actions'
import { Filter } from '../../models/Filter';
import { fetchWishlistItems } from '../../store/wishlist/actions';
import {
    parseShopOrderCollectionFromPath,
    readLastShopReturnContext,
    saveLastShopReturnContext,
} from '../../utils/lastShopReturnContext';

interface State {
    showSidebar: boolean,
    showOrderModal: boolean,
    collectionName: string,
    orderTypeName: string,
    editMode: boolean
}
  
interface OwnProps {
    match?: {params: {collection: string, orderType: string}},
    children?: any
    history?: any
    location?: any
    staticContext?: any
}
  
interface DispatchProps {
    getCollections: (orderType: string) => void
    getOrderTypes: (disallowedTypes?: string[]) => void
    resetFilter: (filter: Filter) => void
    fetchWishlistItems: () => void
}
  
interface StateProps {
    productState: IProductState
    collectionState: ICollectionState
    userSate: IUserSate
    orderState: IOrderState
}
  
type Props = StateProps & OwnProps & DispatchProps;

class MainContainer extends Component<Props, State> {

    state = {
        showSidebar: false,
        showOrderModal: false,
        collectionName: '',
        orderTypeName: '',
        editMode: false
    }

    componentDidMount() {
        this.setMenuItems();

        const { order } = this.props.orderState;

        if (order) {

            if (this.state.editMode && !order) {
                this.setState({ editMode: false })
            }
        }

        if (!this.props.location.pathname.includes('/search')) {
            localStorage.setItem('search:prevPage', this.props.location.pathname);
        }

        if (this.props.userSate.user) {
            this.props.fetchWishlistItems();
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        const { productState, collectionState, location } = this.props;

        const { order } = this.props.orderState;

        if (order) {
            if (order.orderheader.navImportRef && order.orderheader.orderState === 0 && !this.state.editMode) {
                this.setState({ editMode: true }, () => {
                    if (!this.props.location.pathname.includes('/edit') && !this.props.location.pathname.includes('/search')) {
                        // this.props.history.push('/edit')
                    }
                })
            } else if (order.orderheader.navImportRef && order.orderheader.orderState === 0 && this.state.editMode) {
                if (!this.props.location.pathname.includes('/edit') && !this.props.location.pathname.includes('/search')) {
                    // this.props.history.push('/edit')
                }
            }
        }

        if (this.state.editMode && !order) {
            this.setState({ editMode: false })
        }

        if (location !== prevProps.location) {
            this.setMenuItems();
        }

        if (!prevProps.userSate.user && this.props.userSate.user) {
            this.props.fetchWishlistItems();
        }
        
        if ((!productState.orderTypes || !productState.orderTypes.length) && !productState.isFetchingOrderTypes) {
            const disallowedTypes = this.props.userSate.user && this.props.userSate.user.disallowedTypes ? this.props.userSate.user.disallowedTypes : []; 
            this.props.getOrderTypes(disallowedTypes);
        }

        const pathname = (location && location.pathname) || '';
        const prevPathname = (prevProps.location && prevProps.location.pathname) || '';
        const onShopNotWishlist =
            pathname.startsWith('/shop/') && !pathname.startsWith('/shop/wishlist/');

        const fromUrl = parseShopOrderCollectionFromPath(pathname);
        const orderTypeForFetch = (fromUrl && fromUrl.orderType) || this.state.orderTypeName;

        const orderTypeChanged =
            !!this.state.orderTypeName &&
            this.state.orderTypeName !== prevState.orderTypeName;

        const pathChanged = pathname !== prevPathname;

        const noCollections =
            !collectionState.collections || collectionState.collections.length === 0;

        const collectionsWrongOrderType =
            !!orderTypeForFetch &&
            !!collectionState.collectionsOrderType &&
            collectionState.collectionsOrderType !== orderTypeForFetch;

        /** Do not block GetOrderTypeCollections on masters fetch — that prevented filling the list on /shop/OT/COL (e.g. REORDER/SWIM). */
        const canFetchCollectionsList =
            onShopNotWishlist &&
            !!orderTypeForFetch &&
            !collectionState.isFetchingCollections;

        const urlCollectionName = fromUrl && fromUrl.collection;
        const currentCollectionMissingInList =
            !!urlCollectionName &&
            Array.isArray(collectionState.collections) &&
            collectionState.collections.length > 0 &&
            !collectionState.collections.some(
                (c: any) => c && c.collectionName === urlCollectionName
            );

        const shouldFetchCollectionsList =
            canFetchCollectionsList &&
            (
                orderTypeChanged ||
                collectionsWrongOrderType ||
                (noCollections && (pathChanged || orderTypeChanged)) ||
                (pathChanged && currentCollectionMissingInList)
            );

        if (shouldFetchCollectionsList) {
            this.props.getCollections(orderTypeForFetch);
        }

        if (prevProps.orderState.order && this.props.orderState.order &&
            prevProps.orderState.order.orderheader.appOrderId !== this.props.orderState.order.orderheader.appOrderId) {
                const order = this.props.orderState.order;

                if (order.orderheader.navImportRef && order.orderheader.orderState === 0 && !this.state.editMode) {
                    this.setState({ editMode: true }, () => {
                        if (!this.props.location.pathname.includes('/edit') && !this.props.location.pathname.includes('/search')) {
                            // this.props.history.push('/edit')
                        }
                    })
                } else {
                    this.setState({ editMode: false })

                    if (this.props.location.pathname.includes('/edit')) {
                        this.props.history.push('/')
                    }
                }
        }

        if (!this.props.location.pathname.includes('/search')) {
            localStorage.setItem('search:prevPage', this.props.location.pathname);
        }
    }

    setMenuItems = () => {
        let collectionName = '';
        let orderTypeName = '';

        if (this.props.match && this.props.match.params) {
            const c = this.props.match.params.collection;
            const o = this.props.match.params.orderType;
            if (c !== undefined && c !== null) {
                collectionName = String(c);
            }
            if (o !== undefined && o !== null) {
                orderTypeName = String(o);
            }
        }

        const path = (this.props.location && this.props.location.pathname) || '';
        const fromPath = parseShopOrderCollectionFromPath(path);
        if (fromPath) {
            if (!orderTypeName) {
                orderTypeName = fromPath.orderType;
            }
            if (!collectionName) {
                collectionName = fromPath.collection;
            }
        }

        const shopSegments = path.split('/').filter(Boolean);
        const isShopOrderTypeOnly =
            shopSegments.length === 2 &&
            shopSegments[0] === 'shop' &&
            shopSegments[1] !== 'wishlist';

        if (
            !collectionName &&
            orderTypeName &&
            !path.startsWith('/shop/wishlist/') &&
            !isShopOrderTypeOnly
        ) {
            const saved = readLastShopReturnContext();
            if (saved) {
                const fromSaved = parseShopOrderCollectionFromPath(saved.pathname);
                if (fromSaved && fromSaved.orderType === orderTypeName) {
                    collectionName = fromSaved.collection;
                }
            }
        }

        this.setState({
            collectionName,
            orderTypeName,
        });

        const onWishlist = path.startsWith('/shop/wishlist/');
        if (!onWishlist && orderTypeName && collectionName) {
            saveLastShopReturnContext(String(orderTypeName), String(collectionName));
        }
    }

    render() {
        const { children } = this.props;
        
        return (
            <>
                <Header
                    editMode={this.state.editMode}
                    {...this.props}
                />
                <div className="main-content">
                    { children }
                </div>
                <BasketComponent
                    showDropup={true}
                    showDashboardLink={true}
                    editMode={this.state.editMode}
                    {...this.props}
                />
            </>
        )
    }
}

const mapStateToProps = (states: RootState, ownProps: OwnProps): StateProps => {
    return {
        productState: states.productStore.productStore,
        collectionState: states.collections.collections,
        userSate: states.user.user,
        orderState: states.order.order,
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>, ownProps: OwnProps): DispatchProps => {
    return {
        getCollections: async (orderType: string) => {
            await dispatch(getCollections(orderType))
        },
        getOrderTypes: async (disallowedTypes?: string[]) => {
            await dispatch(getOrderTypes(disallowedTypes))
        },
        resetFilter: async (filter: Filter) => {
            await dispatch(resetFilter(filter))
        },
        fetchWishlistItems: async () => {
            await dispatch(fetchWishlistItems())
        },
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(MainContainer)
